<template>
    <div>
        <CRow>
            <CCol class="mfe-2" col="12">
                <div class="d-flex justify-content-between">
                    <CButton color="reddit" @click="collapse = !collapse">
                        {{ $t('table.type_string') }}
                    </CButton>
                </div>
            </CCol>

            <CCol col="12">
                <FilterMe
                    :collapse="collapse"
                    :filters="filters"
                    class="my-2"
                    @onSubmit="filters => filterMe(filters)"
                >
                    <template #form="{filters}">
                        <CRow>
                            <CCol md="6">
                                <CInput
                                    v-model="filters.full_name"
                                    :label="$t('membership_request.full_name')"
                                    :placeholder="$t('membership_request.full_name')"
                                />
                            </CCol>
                            <CCol md="6">
                                <CInput
                                    v-model="filters.mobile"
                                    :label="$t('membership_request.mobile')"
                                    :placeholder="$t('membership_request.mobile')"
                                />
                            </CCol>
                            <CCol md="6">
                                <CInput
                                    v-model="filters.site_name"
                                    :label="$t('membership_request.site_name')"
                                    :placeholder="$t('membership_request.site_name')"
                                />
                            </CCol>
                        </CRow>
                    </template>
                </FilterMe>
            </CCol>
        </CRow>
        <CRow>
            <CCol col="12">
                <CCard>
                    <CCardBody>
                        <CElementCover v-show="showLoading" :opacity="0.8" style="z-index:1"/>
                        <CDataTable
                            :fields="$dataTableFieldsMaker(fields)"
                            :items="Object.values(membershipRequest)"
                            clickableRows
                            hover
                            @row-clicked="goToDetailsPage"
                        >
                            <template #status="{item}">
                                <td>
                                    <span :class="'badge badge-'+statusColor(item.status)">
                                        {{ status(item.status) }}
                                    </span>
                                </td>
                            </template>

                            <template #type="{item}">
                                <td>
                                    {{ setType(item.type) }}
                                </td>
                            </template>

                            <template #site="{item}">
                                <td>
                                    <CLink :href="item.site" target="_blank">
                                        <FaIcon icon="link"></FaIcon>
                                    </CLink>
                                </td>
                            </template>
                        </CDataTable>
                        <CPagination
                            v-if="pagination.last_page > 1"
                            :activePage.sync="pagination.page"
                            :pages="pagination.last_page"
                            align="center" size="sm" @update:activePage="paginationMembershipRequest"/>

                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { FilterMe } from "@/components";
import fields from './partials/fields'
import { setType, status, statusColor } from './partials/methods'

export default {
    name: "MembershipRequest",

    components: {
        FilterMe
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fetch()
        })
    },

    computed: {
        ...mapGetters('membershipRequest', [
            'membershipRequest', 'pagination'
        ]),
        ...mapGetters('filterMeComponent', [
            'filterMeFields'
        ])
    },

    data() {
        return {
            fields,
            filters: {
                mobile: '',
                site_name: '',
                full_name: ''
            },
            showLoading: false,
            collapse: false
        }
    },

    methods: {
        status,
        setType,
        statusColor,
        ...mapActions({
            fetch: 'membershipRequest/fetch'
        }),
        filterMe(filters) {
            this.fetch({
                ...filters,
                page: 1,
            })
        },
        paginationMembershipRequest(activePage, params) {
            this.showLoading = true;
            this.fetch({
                page: activePage,
                ...params,
                ...this.filterMeFields
            }).then(response => {
                this.showLoading = false
            })
            this.pagination.page = activePage
        },
        goToDetailsPage(item) {
            this.$router.push({ name: 'membership-requests.details', params: { id: item.id } })
        },

    }
}
</script>
